module.exports = __webpack_public_path__ + "img/racecourse-greyville-turf-3200.bc0bd932.svg";